import React, { useState, useEffect } from "react";
import DrawMap from "../common/drawmap";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL"; // Assuming redirectURL is an axios instance
import { useParams } from "react-router-dom";

const ShowMap = () => {
  var [show, setShow] = useState(false);
  var [basicTitle, setBasicTitle] = useState("false");
  var [basicType, setBasicType] = useState("info");
  const [title, setTitle] = useState('')
  const [type, setType] = useState('default')
  
  var [consignmentNum, setConsignmentNum] = useState("");
  var [routeTruck, setrouteTruck] = useState({
    truck_no: "",
    startTime: "",
    endTime: "",
  });
    const [loadshow, setLoadShow] = useState("show-n")
  var [overly, setOverlay] = useState("show-n");
  var [maptruckno, setMaptruckno] = useState([]);
  var [rowMapRoute, setrowMapRoute] = useState([]);
  var [googelRoutes, setgoogelRoutes] = useState([]);
  var [tolls, setTolls] = useState([]);
  var [dealer, setDealer] = useState([]);
  var [mapinfo, setmapinfo] = useState([]);
  var [defTransitCoords, setdefTransitCoords] = useState([]);
  var [devation_flag, setdevation_flag] = useState(0);
  var [baseRouteCoords, setbaseRouteCoords] = useState([]);

  const { value } = useParams();

  useEffect(() => {
    const fetchAndLogDetails = async () => {
      try {
        // console.log("useEffect is triggered.");
        // console.log("Params value:", value);

        // setLoadShow("show-m");
        setrowMapRoute([]);
        setTolls([]);
        setdefTransitCoords([]);
        setgoogelRoutes([]);
        setLoadShow("show-m")
        // Base64 decoding with error handling
        let decodedValue;
        try {
          decodedValue = window.atob(value);
        } catch (error) {
          console.error("Error decoding Base64 value:", error);
          setTitle("Invalid Data");
          setType("error");
          setShow(true);
          return;
        }

        const req_uri = decodedValue.split(",");
        // console.log(req_uri, "req_uri123");
        // if (req_uri.length < 5) {
        //   console.error("Decoded value does not contain enough parameters.");
        //   setBasicTitle("Invalid Parameters");
        //   setBasicType("error");
        //   setShow(true);
        //   return;
        // }

        const truck_no = req_uri[0];
        // const from_date = "2024-08-20 17:23:49";
        // const to_date = "2024-08-21 04:12:09";
        
        const from_date =  req_uri[1];
        // console.log(from_date, "form_date6666");

        const to_date = req_uri[2];

        // const consignee_code = req_uri[3];
        const consignment_code = req_uri[5];
        const lr_no = req_uri[3];
        const consignee_code = req_uri[4];
        setConsignmentNum(lr_no);
        setMaptruckno(truck_no);
        setrouteTruck({
          truck_no: truck_no,
          startTime: from_date,
          endTime: to_date,
        });
        setDealer(consignee_code);

        const reqData = {
          truck_no,
          gate_out_time: from_date,
          seconddate: to_date,
          consignment_code,
          screen: "consignment",
          // value: "sentemail",
          // email: "sobha@gmail.com",
          // map_link: "vffefekdwedwj",
        };

        let records;

        const response = await redirectURL.post(
          "/consignments/maproutes",
          reqData
        );
        if(response.data.status.toLowerCase()==="failure"){
          setShow(true);
          setTitle("No data available");
          setType("danger");
          setLoadShow("show-n")
        }else{
        records = (response.data);
      }
        
        // setLoadshow("show-n");



        if (Array.isArray(records.coords) && records.coords.length > 0) {
          
          setmapinfo(records);
          setdevation_flag(0);
          setLoadShow("show-n")

      } else if (records.coords !==undefined && records.coords.length === 0) {

          setShow(true);
          setTitle("No data available");
          setType("danger");
          setLoadShow("show-n")

      } else {

          setShow(true);
          setTitle("No Truck data available");
          setType("danger");
          setLoadShow("show-n")

      }

      } catch (error) {
        console.error("Error fetching map routes:", error);
      }
    };

    // Trigger the function
    fetchAndLogDetails();
  }, [value]);

  const closeAlert = () => {
    setShow(false);
    setLoadShow("show-n");
    setOverlay("show-n");
  };
  const onConfirm = () => {
    setShow(false);
    // setLoader(false)
        window.location.reload()
};

  const onClickHideAll = () => {
    setrowMapRoute([]);
    setTolls([]);
    setgoogelRoutes([]);
    setMaptruckno([]);
  };

  return (
    // (mapinfo.coords && mapinfo.coords.length > 0 &&
    <>
    <SweetAlert
        show={show}
        title={<span style={{ fontSize: "1rem" }}>{title}</span>}
        onConfirm={onConfirm}
        confirmBtnBsStyle={type}
        confirmBtnCssClass="sweetButton"
        customClass='sweetWidth'
        type={type}>
        </SweetAlert>
      <div className={'slide-r ' + 'slider-translate-101p'} style={{ overflow: 'auto' }}>
          <div className="slider-header" style={{margin:"0px"}}>
          <h4 className="slide-r-title">
           LR No - {consignmentNum}
            {/* <a href="javascript:;" className="" id="sclose" onClick={onClickHideAll}>x</a> */}
          </h4>
        </div>      
        <div className="">

      {/* <div className="col-xl-12 col-lg-12" style={{ padding: "0px", margin: "0px", width: "100%", height: "100%", boxSizing: "border-box" }}> */}
        { (
          <DrawMap
            context={this}
            rownode={rowMapRoute}
            mapFor={"shareconsignment1"}
            tolls={tolls}
            googleroutes={googelRoutes}
            truckno={maptruckno}
            dealer={dealer}
            mapinfo={mapinfo}
            defTransitCoords={defTransitCoords}
            dept_code={"SNDG"}
            devation_flag={devation_flag}
            baseRouteCoords={baseRouteCoords}
          />
        )}

        {/* <div className="col-xl-12 col-lg-12"> */}
          <div className="crm-numbers pb-0">
            <h3 className="subH" style={{paddingLeft:"20px"}}>View Details:</h3>
            <div className="col-xl-12 col-lg-12 row">
              <table width="100%" style={{ textAlign: "center" }}>
                <thead>
                  <tr>
                    <th>Vehicle No</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Distance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{routeTruck.truck_no}</td>
                    <td>
                      {routeTruck.startTime !== ""
                        ? routeTruck.startTime
                        : "NA"}
                    </td>
                    <td>
                      {routeTruck.endTime !== "" ? routeTruck.endTime : "NA"}
                    </td>
                    <td>
                      {mapinfo.route_details &&
                      mapinfo.route_details.distance_without_google
                        ? Math.round(
                            mapinfo.route_details.distance_without_google / 1000
                          )
                        : "0"}{" "}
                      Kms
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        {/* </div> */}
        {/* </div> */}

      </div>
      <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                    // onClick={onClickHideAll}
                ></div>
                <div className={"dataLoadpage " + (loadshow)}></div>
                <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
    </div>
    </>
    // )
  );
};

export default ShowMap;
